<template>
  <div class="container_wrap">
    <div class="layout_main layout">
      <Breadcrumbs title="专家团队"></Breadcrumbs>
  
      <div class="live_one live_Multiline fill">
        <div class="content-head has_theme color_1577FE">
          <p><i>▌</i>专家团队</p>
        </div>
        <div class="main_body">
          <div class="list">
  
  
            <div class="item">
              <a class="img" href="/h/spec/sxjtjy/sfyl/2024-10-14/35711.html" target="_blank" title="&nbsp;赵忠心">
                <img src="http://rms.guorent.com/dev/upload/article/779A6D92E45DD95DC8061C8DBFC6910A/1650972626.png">
              </a>
              <div class="item_dl">
                <a href="/h/spec/sxjtjy/sfyl/2024-10-14/35711.html" target="_blank" title="&nbsp;赵忠心"
                  class="item_title hover_theme color_1577FE_hover">
                  &nbsp;赵忠心
                </a>
                <div class="item_detail">
                  中国家庭教育研究第一人，北京师范大学教科所研究员 ，中国教育学会家庭教育专业委员会理事长，国家基础教育实验中心社区与家庭教育研究所所长。
                </div>
              </div>
            </div>
            <div class="item">
              <a class="img" href="/h/spec/sxjtjy/sfyl/2024-10-14/35719.html" target="_blank" title="苑宁宁">
                <img src="http://rms.guorent.com/dev/upload/article/02A1503546215D7B3F5965CE1CAAABA7/1650968514.png">
              </a>
              <div class="item_dl">
                <a href="/h/spec/sxjtjy/sfyl/2024-10-14/35719.html" target="_blank" title="苑宁宁"
                  class="item_title hover_theme color_1577FE_hover">
                  苑宁宁
                </a>
                <div class="item_detail">
                  家庭教育立法专家顾问，家庭教育促进法起草工作领导小组办公室成员，中国政法大学未成年人事务治理与法律研究基地副主任，中国政法大学副教授、法学博士，国务院妇女儿童工作委员会办公室专家智库成员。
                </div>
              </div>
            </div>
            <div class="item">
              <a class="img" href="/h/spec/sxjtjy/sfyl/2024-10-14/35723.html" target="_blank" title="孙云晓">
                <img src="http://rms.guorent.com/dev/upload/article/4C129D3CB512E4051BFE58BF4EF11DE2/1650972060.png">
              </a>
              <div class="item_dl">
                <a href="/h/spec/sxjtjy/sfyl/2024-10-14/35723.html" target="_blank" title="孙云晓"
                  class="item_title hover_theme color_1577FE_hover">
                  孙云晓
                </a>
                <div class="item_detail">
                  中国青少年研究中心家庭教育首席专家，首都师范大学特聘教授，国务院妇儿工委儿童工作智库专家，中国教育学会家庭教育专业委员会常务副理事长。
                </div>
              </div>
            </div>
  
  
            <div class="item">
              <a class="img" href="/h/spec/sxjtjy/sfyl/2024-10-14/35726.html" target="_blank" title="付丽旻">
                <img src="http://rms.guorent.com/dev/upload/article/A1B51B05ECC6AFA1A3043A59236CB782/1650972113.png">
              </a>
              <div class="item_dl">
                <a href="/h/spec/sxjtjy/sfyl/2024-10-14/35726.html" target="_blank" title="付丽旻"
                  class="item_title hover_theme color_1577FE_hover">
                  付丽旻
                </a>
                <div class="item_detail">
                  上海市德育特级教师，德育正高级教师，心理咨询师，上海市劳动模范。
                </div>
              </div>
            </div>
            <!--list.var2-->
            <!--list.var3-->
            <!--list.var4-->
            <!--list.var5-->
            <!--list.var6-->
            <!--list.var7-->
            <!--list.var8-->
            <!--list.var9-->
            <!--list.var10-->
            <!--list.var11-->
            <!--list.var12-->
            <!--list.var13-->
            <!--list.var14-->
            <!--list.var15-->
            <!--list.var16-->
  
            <div class="item">
              <a class="img" href="/h/spec/sxjtjy/sfyl/2024-10-14/35708.html" target="_blank" title="李斌">
                <img src="https://rms.guorent.com/dev/upload/article/DC33E8D6896EA818EF075AFC87E8789B/1723788447.jpg">
              </a>
              <div class="item_dl">
                <a href="/h/spec/sxjtjy/sfyl/2024-10-14/35708.html" target="_blank" title="李斌"
                  class="item_title hover_theme color_1577FE_hover">
                  李斌
                </a>
                <div class="item_detail">
                  高效能家庭学苑首席专家，湖南省教育学会儿童核心素养专委会理事长，华中师范大学心理学院博士生，副教授，心理咨询师。
                </div>
              </div>
            </div>
            <!--list.var2-->
            <!--list.var3-->
            <!--list.var4-->
            <!--list.var5-->
            <!--list.var6-->
            <!--list.var7-->
            <!--list.var8-->
            <!--list.var9-->
            <!--list.var10-->
            <!--list.var11-->
            <!--list.var12-->
            <!--list.var13-->
            <!--list.var14-->
            <!--list.var15-->
            <!--list.var16-->
  
            <div class="item">
              <a class="img" href="/h/spec/sxjtjy/sfyl/2024-10-14/35709.html" target="_blank" title="匡魏锋">
                <img src="https://rms.guorent.com/dev/upload/article/F9FDEA6E34B9A8BF9B2B9A1C48971281/1697004075.png">
              </a>
              <div class="item_dl">
                <a href="/h/spec/sxjtjy/sfyl/2024-10-14/35709.html" target="_blank" title="匡魏锋"
                  class="item_title hover_theme color_1577FE_hover">
                  匡魏锋
                </a>
                <div class="item_detail">
                  江西省心理与健康专业委员会副主任委员，教育部高级心理健康辅导师，南昌心理学会副会长，国务院十二五、十三五计划《家庭教育指导手册》编委。
                </div>
              </div>
            </div>
  
            <div class="item">
              <a class="img" href="/h/spec/sxjtjy/sfyl/2024-10-14/35710.html" target="_blank" title="张晓阳">
                <img src="https://rms.guorent.com/dev/upload/article/A789226971B760060122CEFF6F1B6774/1697004017.png">
              </a>
              <div class="item_dl">
                <a href="/h/spec/sxjtjy/sfyl/2024-10-14/35710.html" target="_blank" title="张晓阳"
                  class="item_title hover_theme color_1577FE_hover">
                  张晓阳
                </a>
                <div class="item_detail">
                  长沙市教育局关工委副主任（兼）、长沙市妇联家庭教育骨干讲师、长沙市教育局家长学校讲师团团长、湖南省教育厅校园健康形象大使、长沙未成年人思想道德建设工作首批专家、中关委湖南家庭教育指导中心专家顾问。
                </div>
              </div>
            </div>
            <!--list.var2-->
            <!--list.var3-->
            <!--list.var4-->
            <!--list.var5-->
            <!--list.var6-->
            <!--list.var7-->
            <!--list.var8-->
            <!--list.var9-->
            <!--list.var10-->
            <!--list.var11-->
            <!--list.var12-->
            <!--list.var13-->
            <!--list.var14-->
            <!--list.var15-->
            <!--list.var16-->
  
            <div class="item">
              <a class="img" href="/h/spec/sxjtjy/sfyl/2024-10-14/35712.html" target="_blank" title="杨敏毅">
                <img src="http://rms.guorent.com/dev/upload/article/ABFD73565BEDA1422A835DFFD188B09C/1650972600.png">
              </a>
              <div class="item_dl">
                <a href="/h/spec/sxjtjy/sfyl/2024-10-14/35712.html" target="_blank" title="杨敏毅"
                  class="item_title hover_theme color_1577FE_hover">
                  杨敏毅
                </a>
                <div class="item_detail">
                  上海市七宝中学心理健康教育中心原主任。上海市首批正高级教师，上海市心理特级教师，国家二级心理咨询师，上海闵行“名师工作室”名师，“杨敏毅工作室”主持人，首届全国学校心理辅导“辅导之星”，首届全国中小学心理健康教育“十佳教师”，全国心理健康教育卓越教师，上海市三八红旗手。擅长团体心理辅导，代表著作有《中学生心理辅导实用技巧与案例》《学校团体心理游戏教程与案例》《团体心理游戏设计与案例》《读懂初中生》《读懂小学生》《做内心强大的教师》《透视孩子的心理世界》等。
                </div>
              </div>
            </div>
            <!--list.var2-->
            <!--list.var3-->
            <!--list.var4-->
            <!--list.var5-->
            <!--list.var6-->
            <!--list.var7-->
            <!--list.var8-->
            <!--list.var9-->
            <!--list.var10-->
            <!--list.var11-->
            <!--list.var12-->
            <!--list.var13-->
            <!--list.var14-->
            <!--list.var15-->
            <!--list.var16-->
  
            <div class="item">
              <a class="img" href="/h/spec/sxjtjy/sfyl/2024-10-14/35713.html" target="_blank" title="王红丽">
                <img src="http://rms.guorent.com/dev/upload/article/9F51F12CEBFAAF3B63D1B125FA77C113/1650972538.png">
              </a>
              <div class="item_dl">
                <a href="/h/spec/sxjtjy/sfyl/2024-10-14/35713.html" target="_blank" title="王红丽"
                  class="item_title hover_theme color_1577FE_hover">
                  王红丽
                </a>
                <div class="item_detail">
                  北京教育科学研究院课程教材研究中心教研员，北京市生涯项目负责人，负责北京市生涯地方课程教材研发、应用与推广。
                </div>
              </div>
            </div>
            <!--list.var2-->
            <!--list.var3-->
            <!--list.var4-->
            <!--list.var5-->
            <!--list.var6-->
            <!--list.var7-->
            <!--list.var8-->
            <!--list.var9-->
            <!--list.var10-->
            <!--list.var11-->
            <!--list.var12-->
            <!--list.var13-->
            <!--list.var14-->
            <!--list.var15-->
            <!--list.var16-->
  
            <div class="item">
              <a class="img" href="/h/spec/sxjtjy/sfyl/2024-10-14/35714.html" target="_blank" title="张冉">
                <img src="http://rms.guorent.com/dev/upload/article/07E3FD0A1DCABCA6A70A0BCE2B3B87D1/1650972523.png">
              </a>
              <div class="item_dl">
                <a href="/h/spec/sxjtjy/sfyl/2024-10-14/35714.html" target="_blank" title="张冉"
                  class="item_title hover_theme color_1577FE_hover">
                  张冉
                </a>
                <div class="item_detail">
                  北京大学教育学院副教授。主要研究领域为教育法学、教育研究方法等。以中英文独自或者与人合作发表论文、书籍章节及百科全书条目数十篇。
                </div>
              </div>
            </div>
            <!--list.var2-->
            <!--list.var3-->
            <!--list.var4-->
            <!--list.var5-->
            <!--list.var6-->
            <!--list.var7-->
            <!--list.var8-->
            <!--list.var9-->
            <!--list.var10-->
            <!--list.var11-->
            <!--list.var12-->
            <!--list.var13-->
            <!--list.var14-->
            <!--list.var15-->
            <!--list.var16-->
  
            <div class="item">
              <a class="img" href="/h/spec/sxjtjy/sfyl/2024-10-14/35715.html" target="_blank" title="宗春山">
                <img src="http://rms.guorent.com/dev/upload/article/FE8D3C4D1029066A3F000BE411DF0663/1650972409.png">
              </a>
              <div class="item_dl">
                <a href="/h/spec/sxjtjy/sfyl/2024-10-14/35715.html" target="_blank" title="宗春山"
                  class="item_title hover_theme color_1577FE_hover">
                  宗春山
                </a>
                <div class="item_detail">
                  北京市家庭教育研究会副秘书长，北京市青少年法律与心理咨询服务中心主任。
                </div>
              </div>
            </div>
            <!--list.var2-->
            <!--list.var3-->
            <!--list.var4-->
            <!--list.var5-->
            <!--list.var6-->
            <!--list.var7-->
            <!--list.var8-->
            <!--list.var9-->
            <!--list.var10-->
            <!--list.var11-->
            <!--list.var12-->
            <!--list.var13-->
            <!--list.var14-->
            <!--list.var15-->
            <!--list.var16-->
  
            <div class="item">
              <a class="img" href="/h/spec/sxjtjy/sfyl/2024-10-14/35716.html" target="_blank" title="王晓春">
                <img src="http://rms.guorent.com/dev/upload/article/8BB40B33C45B2F9A5262372D4F7FB671/1650972382.png">
              </a>
              <div class="item_dl">
                <a href="/h/spec/sxjtjy/sfyl/2024-10-14/35716.html" target="_blank" title="王晓春"
                  class="item_title hover_theme color_1577FE_hover">
                  王晓春
                </a>
                <div class="item_detail">
                  北京教育科学研究院基础教育研究所退休教师，有二十多年一线从教经历，后从事教育科学研究。主要研究方向为教师观念（特别是思维方式）转变，班主任工作，问题学生教育，语文教学，家庭教育等。出版《问题学生诊疗》《今天怎样做教师》《学生问题诊疗69例》等教育专著三十余部。
                </div>
              </div>
            </div>
            <!--list.var2-->
            <!--list.var3-->
            <!--list.var4-->
            <!--list.var5-->
            <!--list.var6-->
            <!--list.var7-->
            <!--list.var8-->
            <!--list.var9-->
            <!--list.var10-->
            <!--list.var11-->
            <!--list.var12-->
            <!--list.var13-->
            <!--list.var14-->
            <!--list.var15-->
            <!--list.var16-->
  
            <div class="item">
              <a class="img" href="/h/spec/sxjtjy/sfyl/2024-10-14/35717.html" target="_blank" title="郝志军">
                <img src="http://rms.guorent.com/dev/upload/article/42EBF9ACC118519B8373357C98873EDE/1650968383.png">
              </a>
              <div class="item_dl">
                <a href="/h/spec/sxjtjy/sfyl/2024-10-14/35717.html" target="_blank" title="郝志军"
                  class="item_title hover_theme color_1577FE_hover">
                  郝志军
                </a>
                <div class="item_detail">
                  中国教育科学研究院课程教学研究所所长，研究员、博士、博士生导师。
                </div>
              </div>
            </div>
            <!--list.var2-->
            <!--list.var3-->
            <!--list.var4-->
            <!--list.var5-->
            <!--list.var6-->
            <!--list.var7-->
            <!--list.var8-->
            <!--list.var9-->
            <!--list.var10-->
            <!--list.var11-->
            <!--list.var12-->
            <!--list.var13-->
            <!--list.var14-->
            <!--list.var15-->
            <!--list.var16-->
  
            <div class="item">
              <a class="img" href="/h/spec/sxjtjy/sfyl/2024-10-14/35718.html" target="_blank" title="洪明">
                <img src="http://rms.guorent.com/dev/upload/article/51EEBD11E7A180CC38A8BAACC15DF84C/1650968497.png">
              </a>
              <div class="item_dl">
                <a href="/h/spec/sxjtjy/sfyl/2024-10-14/35718.html" target="_blank" title="洪明"
                  class="item_title hover_theme color_1577FE_hover">
                  洪明
                </a>
                <div class="item_detail">
                  中国青少年研究中心科研部副主任（主持工作），研究员，教育学博士，中国青少年研究会副秘书长，中国教育学会中青年教育理论工作者分会常务理事，中国家庭教育学会专家指导委员会委员，北京师范大学儿童发展与家庭教育研究院特聘研究员。
                </div>
              </div>
            </div>
            <!--list.var2-->
            <!--list.var3-->
            <!--list.var4-->
            <!--list.var5-->
            <!--list.var6-->
            <!--list.var7-->
            <!--list.var8-->
            <!--list.var9-->
            <!--list.var10-->
            <!--list.var11-->
            <!--list.var12-->
            <!--list.var13-->
            <!--list.var14-->
            <!--list.var15-->
            <!--list.var16-->
  
            <div class="item">
              <a class="img" href="/h/spec/sxjtjy/sfyl/2024-10-14/35720.html" target="_blank" title="罗爽">
                <img src="http://rms.guorent.com/dev/upload/article/FB4B3A93226C356A0EFAD541D2A4A6BA/1650972007.png">
              </a>
              <div class="item_dl">
                <a href="/h/spec/sxjtjy/sfyl/2024-10-14/35720.html" target="_blank" title="罗爽"
                  class="item_title hover_theme color_1577FE_hover">
                  罗爽
                </a>
                <div class="item_detail">
                  首都师范大学教育学院副教授，北京教育法治研究基地副主任。
                </div>
              </div>
            </div>
            <!--list.var2-->
            <!--list.var3-->
            <!--list.var4-->
            <!--list.var5-->
            <!--list.var6-->
            <!--list.var7-->
            <!--list.var8-->
            <!--list.var9-->
            <!--list.var10-->
            <!--list.var11-->
            <!--list.var12-->
            <!--list.var13-->
            <!--list.var14-->
            <!--list.var15-->
            <!--list.var16-->
  
            <div class="item">
              <a class="img" href="/h/spec/sxjtjy/sfyl/2024-10-14/35721.html" target="_blank" title="傅宏">
                <img src="http://rms.guorent.com/dev/upload/article/A05975E3070489C439DEEEED4102A0E7/1650972027.png">
              </a>
              <div class="item_dl">
                <a href="/h/spec/sxjtjy/sfyl/2024-10-14/35721.html" target="_blank" title="傅宏"
                  class="item_title hover_theme color_1577FE_hover">
                  傅宏
                </a>
                <div class="item_detail">
                  南京师范大学心理学院教授、博士生导师。南京师范大学心理学院教授、博士生导师。主要研究领域为儿童青少年心理发展与心理健康。担任教育部中小学心理健康教育专家指导委员会委员，国务院妇儿工委儿童智库专家，中国心理学会理事，江苏省心理学会监事会主席。
                </div>
              </div>
            </div>
            <!--list.var2-->
            <!--list.var3-->
            <!--list.var4-->
            <!--list.var5-->
            <!--list.var6-->
            <!--list.var7-->
            <!--list.var8-->
            <!--list.var9-->
            <!--list.var10-->
            <!--list.var11-->
            <!--list.var12-->
            <!--list.var13-->
            <!--list.var14-->
            <!--list.var15-->
            <!--list.var16-->
  
            <div class="item">
              <a class="img" href="/h/spec/sxjtjy/sfyl/2024-10-14/35722.html" target="_blank" title="刘秀英">
                <img src="http://rms.guorent.com/dev/upload/article/024915D76EEE35A1FA8CD88628C5EF43/1650972044.png">
              </a>
              <div class="item_dl">
                <a href="/h/spec/sxjtjy/sfyl/2024-10-14/35722.html" target="_blank" title="刘秀英"
                  class="item_title hover_theme color_1577FE_hover">
                  刘秀英
                </a>
                <div class="item_detail">
                  中国青少年研究中心家庭教育研究所所长，《少年儿童研究》杂志主编。
                </div>
              </div>
            </div>
            <!--list.var2-->
            <!--list.var3-->
            <!--list.var4-->
            <!--list.var5-->
            <!--list.var6-->
            <!--list.var7-->
            <!--list.var8-->
            <!--list.var9-->
            <!--list.var10-->
            <!--list.var11-->
            <!--list.var12-->
            <!--list.var13-->
            <!--list.var14-->
            <!--list.var15-->
            <!--list.var16-->
  
            <div class="item">
              <a class="img" href="/h/spec/sxjtjy/sfyl/2024-10-14/35724.html" target="_blank" title="李家成">
                <img src="http://rms.guorent.com/dev/upload/article/C9290C36EFD0D66261B895AC28C07DCF/1650972079.png">
              </a>
              <div class="item_dl">
                <a href="/h/spec/sxjtjy/sfyl/2024-10-14/35724.html" target="_blank" title="李家成"
                  class="item_title hover_theme color_1577FE_hover">
                  李家成
                </a>
                <div class="item_detail">
                  上海终身教育研究院执行副院长，华东师范大学教育学系教授，博士生导师。
                </div>
              </div>
            </div>
            <!--list.var2-->
            <!--list.var3-->
            <!--list.var4-->
            <!--list.var5-->
            <!--list.var6-->
            <!--list.var7-->
            <!--list.var8-->
            <!--list.var9-->
            <!--list.var10-->
            <!--list.var11-->
            <!--list.var12-->
            <!--list.var13-->
            <!--list.var14-->
            <!--list.var15-->
            <!--list.var16-->
  
            <div class="item">
              <a class="img" href="/h/spec/sxjtjy/sfyl/2024-10-14/35725.html" target="_blank" title="迟希新">
                <img src="http://rms.guorent.com/dev/upload/article/93944D1C2ACA142D7AC2E321C4A7753C/1650972097.png">
              </a>
              <div class="item_dl">
                <a href="/h/spec/sxjtjy/sfyl/2024-10-14/35725.html" target="_blank" title="迟希新"
                  class="item_title hover_theme color_1577FE_hover">
                  迟希新
                </a>
                <div class="item_detail">
                  北京教育学院校长研修学院教授，德育与班级管理研究中心主任，教育学博士。
                </div>
              </div>
            </div>
            <!--list.var2-->
            <!--list.var3-->
            <!--list.var4-->
            <!--list.var5-->
            <!--list.var6-->
            <!--list.var7-->
            <!--list.var8-->
            <!--list.var9-->
            <!--list.var10-->
            <!--list.var11-->
            <!--list.var12-->
            <!--list.var13-->
            <!--list.var14-->
            <!--list.var15-->
            <!--list.var16-->
  
            <div class="item">
              <a class="img" href="/h/spec/sxjtjy/sfyl/2024-10-14/35727.html" target="_blank" title="晏红">
                <img src="http://rms.guorent.com/dev/upload/article/72567AC76B9642017941383C6A293DA9/1650972135.png">
              </a>
              <div class="item_dl">
                <a href="/h/spec/sxjtjy/sfyl/2024-10-14/35727.html" target="_blank" title="晏红"
                  class="item_title hover_theme color_1577FE_hover">
                  晏红
                </a>
                <div class="item_detail">
                  清华大学教育博士，北京市特级教师，北京市幼教学科带头人，中国家庭教育学会理事，中国青少年研究会理事。
                </div>
              </div>
            </div>
            <!--list.var2-->
            <!--list.var3-->
            <!--list.var4-->
            <!--list.var5-->
            <!--list.var6-->
            <!--list.var7-->
            <!--list.var8-->
            <!--list.var9-->
            <!--list.var10-->
            <!--list.var11-->
            <!--list.var12-->
            <!--list.var13-->
            <!--list.var14-->
            <!--list.var15-->
            <!--list.var16-->
  
            <div class="item">
              <a class="img" href="/h/spec/sxjtjy/sfyl/2024-10-14/35728.html" target="_blank" title="关颖">
                <img src="http://rms.guorent.com/dev/upload/article/4780F0A003D2B0E1A1481CF0BDE72E3E/1650972153.png">
              </a>
              <div class="item_dl">
                <a href="/h/spec/sxjtjy/sfyl/2024-10-14/35728.html" target="_blank" title="关颖"
                  class="item_title hover_theme color_1577FE_hover">
                  关颖
                </a>
                <div class="item_detail">
                  天津社会科学院社会学研究所研究员，受聘国家教育行政学院家庭教育研究中心兼职教授。
                </div>
              </div>
            </div>
            <!--list.var2-->
            <!--list.var3-->
            <!--list.var4-->
            <!--list.var5-->
            <!--list.var6-->
            <!--list.var7-->
            <!--list.var8-->
            <!--list.var9-->
            <!--list.var10-->
            <!--list.var11-->
            <!--list.var12-->
            <!--list.var13-->
            <!--list.var14-->
            <!--list.var15-->
            <!--list.var16-->
  
            <div class="item">
              <a class="img" href="/h/spec/sxjtjy/sfyl/2024-10-14/35729.html" target="_blank" title="陈延斌">
                <img src="http://rms.guorent.com/dev/upload/article/1BD8799A671D106BD815DA51AD7B029A/1650972172.png">
              </a>
              <div class="item_dl">
                <a href="/h/spec/sxjtjy/sfyl/2024-10-14/35729.html" target="_blank" title="陈延斌"
                  class="item_title hover_theme color_1577FE_hover">
                  陈延斌
                </a>
                <div class="item_detail">
                  江苏省文科重点研究基地江苏师大中华家文化研究院院长，黄河科技学院中华文化传承发展研究院院长，二级教授、博士生导师。
                </div>
              </div>
            </div>
            <!--list.var2-->
            <!--list.var3-->
            <!--list.var4-->
            <!--list.var5-->
            <!--list.var6-->
            <!--list.var7-->
            <!--list.var8-->
            <!--list.var9-->
            <!--list.var10-->
            <!--list.var11-->
            <!--list.var12-->
            <!--list.var13-->
            <!--list.var14-->
            <!--list.var15-->
            <!--list.var16-->
  
            <div class="item">
              <a class="img" href="/h/spec/sxjtjy/sfyl/2024-10-14/35730.html" target="_blank" title="曾小玲">
                <img src="https://rms.guorent.com/dev/upload/article/0D58AEEC6181956D9234971C1EECCAC7/1664434385.png">
              </a>
              <div class="item_dl">
                <a href="/h/spec/sxjtjy/sfyl/2024-10-14/35730.html" target="_blank" title="曾小玲"
                  class="item_title hover_theme color_1577FE_hover">
                  曾小玲
                </a>
                <div class="item_detail">
                  湖南第一师范学院二级教授，硕士生导师，湖南省“神箭”英才导师奖，湖南省优秀青年女性。教育部“校长国培计划”专家库专家，教育部中小学教师国家级培训专家库专家。
                </div>
              </div>
            </div>
            <!--list.var2-->
            <!--list.var3-->
            <!--list.var4-->
            <!--list.var5-->
            <!--list.var6-->
            <!--list.var7-->
            <!--list.var8-->
            <!--list.var9-->
            <!--list.var10-->
            <!--list.var11-->
            <!--list.var12-->
            <!--list.var13-->
            <!--list.var14-->
            <!--list.var15-->
            <!--list.var16-->
  
            <div class="item">
              <a class="img" href="/h/spec/sxjtjy/sfyl/2024-10-14/35731.html" target="_blank" title="李君健">
                <img src="https://rms.guorent.com/dev/upload/article/C3D0D072B6FC7F5643AC1CC88DF46DC2/1714980334.png">
              </a>
              <div class="item_dl">
                <a href="/h/spec/sxjtjy/sfyl/2024-10-14/35731.html" target="_blank" title="李君健"
                  class="item_title hover_theme color_1577FE_hover">
                  李君健
                </a>
                <div class="item_detail">
                  李君健，湖南省益阳市益阳开放大学讲师，益阳市妇联家庭教育研究会副秘书长、益阳市教育局关工委家庭教育讲师团讲师。国家二级心理咨询师。长期从事家庭教育工作，在该领域拥有深厚的理论知识和丰富的实践经验。曾在桃江县开展“百人课堂、百堂精品、百名教师”家庭教育公益讲座，围绕未成年人培养学习兴趣，改正不良行为习惯，进行心理调节等话题展开互动。她的《“如何做一个智慧型家长”》获得中国社区教育网教育部社区教育研究培训中心家庭教育优质课程资源征集与共享行动推介课程。她录制的《孩子成长的双面镜——胆小和没大没小》获得2024年湖南省妇女联合会家庭教育精品课程二等奖，同时入围2024年益阳市妇女联合会家庭教育精品课程，荣获二等奖。
                </div>
              </div>
            </div>
            <!--list.var2-->
            <!--list.var3-->
            <!--list.var4-->
            <!--list.var5-->
            <!--list.var6-->
            <!--list.var7-->
            <!--list.var8-->
            <!--list.var9-->
            <!--list.var10-->
            <!--list.var11-->
            <!--list.var12-->
            <!--list.var13-->
            <!--list.var14-->
            <!--list.var15-->
            <!--list.var16-->
  
  
  
  
  
          </div>
          <div class="digg"></div>
  
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import Breadcrumbs from './component/breadcrumb.vue';
import Pagination from './component/pagination.vue';
export default {
  name: 'NetworkingIndex',
  components: {
    Breadcrumbs,
    Pagination
  },
  data() {
    return {
      type: this.$route.params.type,
      // 数据可以根据实际需要进行调整
      items: [
        { title: '山西省第三届家庭教育指导技能大赛', link: 'https://org.ttcdw.cn/project/983123849693712384' },
        { title: '山西省第二届家庭教育指导技能大赛', link: 'https://org.ttcdw.cn/project/903439760222658560' }
      ],
      totalItems: 20, // 总条数
      currentPage: 1, // 当前页码
      itemsPerPage: 10 // 每页条数
    };
  },
  computed: {
    // 根据 type 动态计算标题
    computedTitle() {
      const titleMap = {
        0: '技能大赛',
        1: '大赛相关',

      };
      return titleMap[this.type];
    }
  },
  mounted() {
    document.title = '山西省第三届家庭教育指导技能大赛';
  },
  methods: {
    handlePageChange(page) {
      this.currentPage = page;
      // 在这里可以添加逻辑来处理页面变化，比如重新加载数据
      console.log(`当前页码: ${this.currentPage}`);
    }
  }
};

</script>
<style lang="scss" scoped>
.container_wrap {
  width: 100%;
  min-width: 1200px;
  overflow: hidden;

  .layout_main {
    padding: 20px 0 30px 0;

    .categoryList {
      padding-top: 20px;
      margin-bottom: 10px;

      .clearfix:before,
      .clearfix:after {
        content: "";
        display: table;
      }

      .clearfix:after {
        visibility: hidden;
        display: block;
        font-size: 0;
        content: " ";
        clear: both;
        height: 0;
      }


    }

    .live_one {
      width: 100%;
      padding-top: 30px;

      .color_1577FE {
        color: #1577fe;
      }

      .main_body {
        padding-top: 20px;
        padding-bottom: 15px;



        .list {
          margin-top: 2px;
          display: flex;
          justify-content: space-between;
          flex-wrap: wrap;
        }
      }

      .item {
        margin-bottom: 30px;
        width: 594px;
        background: #f6f7fa;
        padding: 20px 29px 20px 20px;
        display: flex;
        flex-wrap: wrap;
        position: relative;

        .img {
          width: 128px;
          height: 128px;
          padding: 5px;
          box-sizing: border-box;
          background-color: #E1E0E0;
          margin-right: 21px;
          border-radius: 50%;

          img {
            width: 100%;
            height: 100%;
            border-radius: 50%;
          }
        }

        .item_dl {
          width: 395px;
          padding-top: 10px;
          box-sizing: border-box;

          .item_title {
            width: 100%;
            display: block;
            font-size: 18px;
            font-weight: 400;
            color: #333333;
            line-height: 24px;
            height: 24px;
            overflow: hidden;
            text-overflow: ellipsis;
            white-space: nowrap;
            word-break: break-all;
            margin-bottom: 10px;
          }

          .color_1577FE_hover:hover {
            color: #1577fe !important;
          }

          .item_detail {
            line-height: 24px;
            max-height: 48px;
            font-size: 14px;
            font-weight: 400;
            color: #999999;
            display: -webkit-box;
            -webkit-box-orient: vertical;
            -webkit-line-clamp: 2;
            overflow: hidden;
            text-overflow: ellipsis;
            word-break: break-all;
          }
        }




      }

      a {
        display: block;
        position: relative;
      }
    }

    .fill {
      .color_1577FE p {
        color: #1577fe;
      }

      .content-head p {
        font-size: 20px;
        font-weight: 500;
        line-height: 28px;
        letter-spacing: 1px;

        i {
          display: inline-block;
          font-weight: bold;
          margin-right: 5px;
          line-height: 28px;
          font-size: 16px;
          font-style: normal;
          text-indent: 5px;
        }
      }
    }
  }

  .layout {
    width: 1200px;
    margin: 0 auto;
  }
}
</style>